import { createContext, useContext, useEffect, useRef, useState } from 'react';
import keycloak from '../auth/keycloak';
import baseapi from '../services/baseapi';
import { showError } from '../utils/toast';
import { jwt_decode } from '../utils/jwt_decode';
import * as microsoftTeams from '@microsoft/teams-js';
import { jwtDecode } from 'jwt-decode';
// import { handleLogout } from '../auth/logout';
interface AuthContextType {
  isAuthenticated: boolean;
  isInitialized: boolean;
  keycloak: typeof keycloak;
}

const AuthContext = createContext<AuthContextType | undefined>(undefined);

export const AuthProvider = ({ children }: { children: React.ReactNode }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isInitialized, setIsInitialized] = useState(false);
  const isKeycloakInitialized = useRef(false); // ✅ Prevent double init

  const permissions = async () => {
    try {
      const response = await baseapi('/me')
      if (response.data) {
        localStorage.setItem('user', JSON.stringify(response.data.user))
        localStorage.setItem('ticketing_domain', response.data.user.ticketing_domain)
        localStorage.setItem('permissions', JSON.stringify(response.data.user.permissions))
        localStorage.setItem('client_ids', response.data.user.client_ids)
        localStorage.setItem('request_host', response.data.user.request_host)
        const host = response.data.user.request_host || response.data.user.custom_domain || response.data.user.ticketing_domain;
        if (host) {
          const cleanHost = host.replace(/^https?:\/\//, '').replace(/\/$/, '');
          localStorage.setItem('custom_domain', cleanHost);
        }
      }
      else {
        showError(response.data.message)
      }
    } catch (error: any) {
      // handleLogout()
      showError(error.message)
    }
  }
  const fetchAndStoreSettings = async (lvl: any) => {
    try {
      const decoded = jwt_decode();
      const orgId = decoded?.organization_id ? Number(decoded.organization_id) : null;
      const clientId = lvl?.name === 'global' ? null : (lvl?.id ? Number(lvl.id) : null);

      const queryObj: any = { client_id: clientId };
      if (orgId !== null) {
        queryObj.organization_id = orgId;
      }

      const response = await baseapi.get('/settings/', {
        params: { query: JSON.stringify(queryObj) }
      });

      let activeSettings: any = null;
      if (response.data && response.data.status) {
        const resData = response.data.data;
        if (Array.isArray(resData) && resData.length > 0) {
          activeSettings = resData[0];
        } else if (resData && !Array.isArray(resData)) {
          activeSettings = resData;
        }
      }

      if (activeSettings) {
        const tz = activeSettings.timezone || 'UTC';
        const bkLogoKey = activeSettings.logo || '';

        let agentColsOrder = undefined;
        let agentSortKey = undefined;
        let agentSortDir = undefined;

        let eventColsOrder = undefined;
        let eventSortKey = undefined;
        let eventSortDir = undefined;

        let assetColsOrder = undefined;
        let assetSortKey = undefined;
        let assetSortDir = undefined;

        let tableSettingsArray = activeSettings.table_settings;
        if (typeof tableSettingsArray === 'string') {
          try {
            tableSettingsArray = JSON.parse(tableSettingsArray);
          } catch (e) {
            console.error("Failed to parse table_settings string", e);
          }
        }

        if (tableSettingsArray && Array.isArray(tableSettingsArray)) {
          const agentTS = tableSettingsArray.find((t: any) => t.table_name === 'agent' || t.key === 'agent');
          if (agentTS) {
            agentColsOrder = agentTS.column_order || agentTS.columnOrder || agentTS.columns;
            agentSortKey = agentTS.default_sort_key || agentTS.defaultSortKey || agentTS.sortKey;
            agentSortDir = agentTS.default_sort_dir || agentTS.defaultSortDir || agentTS.sortDir;
          }

          const eventTS = tableSettingsArray.find((t: any) => t.table_name === 'event' || t.key === 'event');
          if (eventTS) {
            eventColsOrder = eventTS.column_order || eventTS.columnOrder || eventTS.columns;
            eventSortKey = eventTS.default_sort_key || eventTS.defaultSortKey || eventTS.sortKey;
            eventSortDir = eventTS.default_sort_dir || eventTS.defaultSortDir || eventTS.sortDir;
          }

          const assetTS = tableSettingsArray.find((t: any) => t.table_name === 'asset' || t.key === 'asset');
          if (assetTS) {
            assetColsOrder = assetTS.column_order || assetTS.columnOrder || assetTS.columns;
            assetSortKey = assetTS.default_sort_key || assetTS.defaultSortKey || assetTS.sortKey;
            assetSortDir = assetTS.default_sort_dir || assetTS.defaultSortDir || assetTS.sortDir;
          }
        }

        const formatted = {
          logo: bkLogoKey,
          timezone: tz,
          columnOrder: agentColsOrder,
          defaultSortKey: agentSortKey,
          defaultSortDir: agentSortDir,
          eventColumnOrder: eventColsOrder,
          eventDefaultSortKey: eventSortKey,
          eventDefaultSortDir: eventSortDir,
          assetColumnOrder: assetColsOrder,
          assetDefaultSortKey: assetSortKey,
          assetDefaultSortDir: assetSortDir
        };

        localStorage.setItem('organization_settings', JSON.stringify(formatted));
        window.dispatchEvent(new CustomEvent('organization-settings-changed'));
      } else {
        localStorage.removeItem('organization_settings');
        window.dispatchEvent(new CustomEvent('organization-settings-changed'));
      }
    } catch (err) {
      console.error("Failed to fetch and store settings", err);
    }
  };

  useEffect(() => {
    const handleClientChange = (e: Event) => {
      const ev = e as CustomEvent;
      if (ev.detail) {
        fetchAndStoreSettings(ev.detail);
      }
    };
    window.addEventListener('client-level-changed', handleClientChange);
    return () => window.removeEventListener('client-level-changed', handleClientChange);
  }, []);














  // ✅ ADDED: Helper for Token Exchange
  const handleTeamsTokenExchange = async (ssoToken: string) => {

    console.log("checking", window.location.origin)
    const response = await fetch(`${window.location.origin}/iv1/auth/teams-sso-exchange`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${ssoToken}`,
        'Content-Type': 'application/json'
      }
    });

    if (!response.ok) {
      throw new Error(`Backend authentication failed: ${response.status}`);
    }

    const result = await response.json();
    console.log("Backend response:", result);
    console.log("keyyyyyy:", result.access_token);
    console.log('✅ Keycloak tokens received from backend');

    localStorage.setItem('access_token', result.access_token || '');
    localStorage.setItem('refresh_token', result.refresh_token || '');
    localStorage.setItem('id_token', result.access_token || '');

    const rawDomain = result.custom_domain || result.request_host || result.domain || result.ticketing_domain;
    let cleanDomain = '';
    if (rawDomain) {
      cleanDomain = rawDomain.replace(/^https?:\/\//, '').replace(/\/$/, '');
    } else if (result.access_token) {
      try {
        const decoded: any = jwtDecode(result.access_token);
        if (decoded?.iss) {
          cleanDomain = new URL(decoded.iss).hostname;
        }
      } catch (e) {
        console.error("Failed to decode token for domain", e);
      }
    }

    if (cleanDomain) {
      localStorage.setItem('custom_domain', cleanDomain);
      console.log('✅ Custom domain stored in localStorage:', cleanDomain);
    } else {
      localStorage.setItem('custom_domain', result.custom_domain || '');
    }

    return result;
  };

  useEffect(() => {
    if (isKeycloakInitialized.current) return; // ✅ Skip re-initialization

    // Check if running inside Microsoft Teams (from URL or localStorage)
    const teamsParamInUrl = new URLSearchParams(window.location.search).get('teams') === 'true';
    const teamsInLocalStorage = localStorage.getItem('inTeams') === 'true';
    const inTeams = teamsParamInUrl || teamsInLocalStorage;
    console.log("in teams is", inTeams)

    // Store Teams mode in localStorage if detected from URL
    if (teamsParamInUrl) {
      localStorage.setItem('inTeams', 'true');
      console.log('✅ Teams mode stored in localStorage');
    }
    if (inTeams) {
      // Teams SSO Flow
      console.log('🔵 Teams mode detected - initializing Teams SSO');

      // ✅ CHANGED: Wrapped initialization to handle Timeout & Race condition
      const initTeams = async () => {
        try {
          // 1. Race condition fix for AppInitTimeout
          await Promise.race([
            microsoftTeams.app.initialize(),
            new Promise((resolve) => setTimeout(resolve, 1000))
          ]);

          // 2. Stop the 45s Watchdog Timeout
          try { microsoftTeams.app.notifySuccess(); } catch (e) { }

          console.log('✅ Teams SDK initialized');

          await microsoftTeams.app.getContext(); // Safe to call now

          const ssoToken = await microsoftTeams.authentication.getAuthToken();
          console.log('✅ Teams SSO token received');
          console.log('Teams SSO token:', ssoToken);

          // Exchange token using helper
          // const result = await handleTeamsTokenExchange(ssoToken);
          await handleTeamsTokenExchange(ssoToken);
          isKeycloakInitialized.current = true;
          setIsAuthenticated(true);

          // const decoded_jwt: any = jwtDecode(result.access_token || '');
          // localStorage.setItem('currentPage', '1');
          // localStorage.setItem('ticketLimit', '50');
          // await permissions();
          // if (decoded_jwt.user_role === 'entra_guest' || !decoded_jwt.user_role) {
          //   navigate('/pendingaccess?teams=true', { replace: true });
          // } else if (decoded_jwt.user_role === 'field_engineer') {
          //   navigate('/tasks?teams=true', { replace: true });
          // } else {
          //   const landing = getLandingRoute();
          //   navigate(landing ? `${landing}?teams=true` : '/tickets?teams=true', { replace: true });
          // }

          // if (decoded_jwt.user_role && decoded_jwt.user_role !== 'entra_guest') {
          //   // await fetchIntegrations();
          //   await fetchUserSettings();
          //   if (decoded_jwt.user_type === "internal") {
          //     await fetchOrganizationUIPreferences(); // ✅ Call here
          //   }
          // }

          let initialLevel = { name: 'global' };
          const storedLvl = localStorage.getItem('level');
          if (!storedLvl) {
            localStorage.setItem('level', JSON.stringify(initialLevel));
          } else {
            try {
              initialLevel = JSON.parse(storedLvl);
            } catch (e) {
              console.error(e);
            }
          }
          await permissions();
          fetchAndStoreSettings(initialLevel);
          setIsInitialized(true);

        } catch (error: any) {
          console.error('❌ Teams SSO authentication failed:', error);
          showError(error.message || 'Teams SSO authentication failed');
          setIsAuthenticated(false);
          setIsInitialized(true);
        }
      };

      initTeams();

    } else {

      keycloak
        .init({
          onLoad: 'check-sso',
          checkLoginIframe: false,
        })
        .then((auth) => {
          isKeycloakInitialized.current = true; // ✅ Mark as initialized

          setIsAuthenticated(auth);

          if (auth) {
            localStorage.setItem('access_token', keycloak.token || '');
            localStorage.setItem('id_token', keycloak.idToken || '');
            let initialLevel = { name: 'global' };
            const storedLvl = localStorage.getItem('level');
            if (!storedLvl) {
              localStorage.setItem('level', JSON.stringify(initialLevel));
            } else {
              try {
                initialLevel = JSON.parse(storedLvl);
              } catch (e) {
                console.error(e);
              }
            }
            setTokenRefresh();
            permissions();
            fetchAndStoreSettings(initialLevel);
          }

          setIsInitialized(true);
        })
        .catch(() => {
          setIsAuthenticated(false);
          setIsInitialized(true);
        });

    }

  }, []); // ✅ Only run once on mount

  const setTokenRefresh = () => {
    setInterval(() => {
      keycloak
        .updateToken(120)
        .then((refreshed) => {
          if (refreshed) {
            localStorage.setItem('access_token', keycloak.token || '');
            // localStorage.setItem('refresh_token', keycloak.refreshToken || '');
            localStorage.setItem('id_token', keycloak.idToken || '');
            // permissions();

          }
        })
        .catch(() => {
          localStorage.clear();
          keycloak.logout({ redirectUri: window.location.origin });
        });
    }, 60 * 1000);
  };



  return (
    <AuthContext.Provider value={{ isAuthenticated, isInitialized, keycloak }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) throw new Error('useAuth must be used within an AuthProvider');
  return context;
};
